<template>
    <div v-if="res" class="suc">
        خرید شما با موفقیت انجام شد
        <br>
        <RouterLink class="bt" :to="{ path: '/manage-factor' }">
            مدیریت
        </RouterLink>
        <br>
        <PackageShablone :data="packageChoosen"/>
    </div>
    <div v-else class="err">
        عملیات با شکست روبرو شد
        <RouterLink class="bt" :to="{ path: '/' }">
            خانه
        </RouterLink>
    </div>
</template>
<script setup>
    import { defineProps,onMounted, ref } from 'vue'
    import { useFactorStore } from '@/stores/factor';
    import PackageShablone from '@/components/dashboard/bodys/factor/PackageShablone.vue';
    const factor = useFactorStore()
    const props = defineProps({
        factorId:Number,
        factor:String,
        mobile:String,
        packId:Number
    })
    const packageChoosen = ref([])
    const res = ref(false)
    onMounted(async () => {
        res.value = await factor.addResponse({
            factorId:props.factorId,
            factor:props.factor,
            mobile:props.mobile,
            packId:props.packId,
        })
        if(res.value){
            packageChoosen.value = factor.selectPackageWhereId(props.packId)
        }
    })
</script>
<style scoped>
    .suc , .err {
        padding: 40px;
        width: 70%;
        margin: 30px auto;
    }
    .suc , .err ,.bt{
        text-align: center;
        border-radius: 10px;
        color: white;
    }
    .err {
        background-color: red;
    }
    .suc{
        background-color: green;
    }
    .bt {
        display: block;
        width: 100%;
        margin: 10px 0;
        padding: 20px;
        background-color: blue;
    }
</style>